import { client } from '../client';
import { UpdateCollectorUserPayload } from './collectorUserEditPayload';
import { normalizeCollectorUserResponse } from './normalizeCollectorUserResponse';
import { UserProfile } from './types/UserProfile';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

/**
 * POST /<role>/users — JSON body (snake_case), same core shape as PATCH + optional onboarding fields.
 * Defaults to /collector/users when no userRole is supplied.
 */
export interface CreateCollectorUserPayload extends UpdateCollectorUserPayload {
  email?: string | null;
  type?: string;
  organization_ids?: string[];
  division_ids?: string[];
  practice_ids?: string[];
  send_invitation?: boolean;
  is_quick_add?: boolean;
  full_name?: string;
  frontend_website?: string;
}

const isDev = process.env.NODE_ENV === 'development';

export const createCollectorUser = async (
  payload: CreateCollectorUserPayload,
  userRole?: string,
): Promise<UserProfile> => {
  try {
    JSON.stringify(payload);
  } catch {
    throw new Error('INVALID_COLLECTOR_USER_JSON');
  }

  const prefix = getStaffScopedApiPrefix(userRole) || '/collector';
  const url = `${prefix}/users`;

  if (isDev) {
    // eslint-disable-next-line no-console
    console.info('[createCollectorUser] POST', url, payload);
  }

  const { data } = await client.post<UserProfile | undefined>(url, payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (data == null) {
    throw new Error('CREATE_COLLECTOR_USER_EMPTY_RESPONSE');
  }

  return normalizeCollectorUserResponse(data);
};
